/* eslint-disable no-unused-vars */
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Box, Button, Card, CardContent, makeStyles, Typography,
} from '@material-ui/core';
import PropTypes from 'prop-types';

import ListAnswers from './ListAnswers';
import ScoreCard from './ScoreCard';

const useStyles = makeStyles((theme) => ({
  pageTitle: {
    color: theme.palette.text.default,
    fontFamily: 'Raleway',
    textAlign: 'center',
  },
  pageTitleMargin: {
    margin: theme.spacing(0, 0, 4, 0),
  },
  card: {
    background: 'transparent',
    margin: theme.spacing(2),
    border: `1px solid ${theme.palette.background.default}`,
    borderRadius: 10,
    color: theme.palette.text.default,
    maxWidth: 750,
    padding: theme.spacing(0, 4),
  },
  cardTitle: {
    fontFamily: 'Raleway',
    textAlign: 'center',
    fontSize: 24,
  },
  cardContainerScoreCards: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    margin: theme.spacing(2),
  },
  buttonNextLesson: {
    fontFamily: 'Raleway',
  },
  buttonOnlined: {
    color: theme.palette.background.info,
    border: 'solid 1px',
    borderColor: theme.palette.background.info,
    fontFamily: 'Raleway',
  },
  containerButtonNext: {
    margin: theme.spacing(4, 2, 0, 2),
  },
  containerButtonsFail: {
    margin: theme.spacing(4, 2, 0, 2),
    display: 'flex',
    justifyContent: 'space-between',
  },
}));
function FinalQuizz({
  correct, incorrect, total, userAnswers, correctAnswers, listQuestions, completedTopic,
}) {
  const classes = useStyles();
  const location = useLocation();
  const navigate = useNavigate();
  const [listAnswers, setListAnswers] = useState([]);
  const [isApproved, setIsApprovated] = useState(false);

  const recognizeCorrectAnswers = () => {
    const request = correctAnswers.map((e, index) => {
      const { answer, question, id } = e;
      return {
        correctAnswer: answer,
        question,
        id,
        userAnswers: userAnswers[index].answer,
        correct: userAnswers[index].answer === answer,
      };
    });
    setListAnswers(request);
    const percent = Math.trunc(listQuestions / 2) + 1;
    setIsApprovated(correct >= percent);
  };

  useEffect(() => {
    recognizeCorrectAnswers();
  }, []);

  return (
    <Box>
      { isApproved ? (
        <Box className={classes.pageTitleMargin}>
          <Typography variant="h4" className={classes.pageTitle}>¡Felicitaciones!</Typography>
          <Typography variant="h4" className={classes.pageTitle}>Aprobaste Evaluación</Typography>
        </Box>
      ) : (
        <Box className={classes.pageTitleMargin}>
          <Typography variant="h4" className={classes.pageTitle}>Lo sentimos, no aprobaste la evaluación</Typography>
          <Typography className={classes.pageTitle}>
            Te invitamos a repasar las lecciones anteriores para que refuerces tus conocimientos
          </Typography>
        </Box>
      )}
      <Card className={classes.card}>
        <CardContent className={classes.cardContent}>
          <Box>
            <Typography className={classes.cardTitle}>Resumen de tus resultados:</Typography>
            <Box className={classes.cardContainerScoreCards}>
              <ScoreCard score={total} textCard="Preguntas en total" />
              <ScoreCard score={correct} textCard="Respuestas correctas" />
              <ScoreCard score={incorrect} textCard="Respuestas incorrectas" />
            </Box>
          </Box>
          <Box>
            <Typography className={classes.cardTitle}>Respuestas:</Typography>
            <Box sx={{
              height: 200,
              overflowY: 'scroll',
              '&::-webkit-scrollbar': {
                width: 7,
              },
              '&::-webkit-scrollbar-track': {
                background: 'transparent',
              },
              '&::-webkit-scrollbar-thumb': {
                height: 15,
                width: 2,
                background: '#FCD050',
                borderRadius: 10,
              },
            }}
            >
              <ListAnswers list={listAnswers} />
            </Box>
          </Box>
        </CardContent>
      </Card>
      { isApproved ? (
        <Box className={classes.containerButtonNext}>
          {completedTopic ? (
            <Button
              variant="outlined"
              className={classes.buttonOnlined}
              onClick={() => navigate('/finished', {
                state: {
                  name: location.state.nameCourse,
                  course: location.state.course,
                  finalCourse: false,
                  theme: true,
                },
              })}
            >
              Siguiente tema

            </Button>
          )
            : (
              <Button
                variant="outlined"
                className={classes.buttonOnlined}
                onClick={() => navigate('/statistics', {
                  state: {
                    course: location.state.course,
                    topic: location.state.topic,
                  },
                })}
              >
                Continuar
              </Button>
            )}
        </Box>
      ) : (
        <Box className={classes.containerButtonsFail}>
          <Button
            variant="contained"
            color="secondary"
            className={classes.buttonNextLesson}
            onClick={() => navigate('/statistics', {
              state: {
                course: location.state.course,
                topic: location.state.topic,
              },
            })}
          >
            Repasar lecciones

          </Button>
          {completedTopic ? (
            <Button
              variant="outlined"
              className={classes.buttonOnlined}
              onClick={() => navigate('/finished', {
                state: {
                  name: location.state.nameCourse,
                  course: location.state.course,
                  finalCourse: false,
                  theme: true,
                },
              })}
            >
              Siguiente tema

            </Button>
          )
            : (
              <Button
                variant="outlined"
                className={classes.buttonOnlined}
                onClick={() => navigate('/statistics', {
                  state: {
                    course: location.state.course,
                    topic: location.state.topic,
                  },
                })}
              >
                Continuar
              </Button>
            )}
        </Box>
      )}
    </Box>
  );
}

export default FinalQuizz;

FinalQuizz.propTypes = {
  correct: PropTypes.number.isRequired,
  incorrect: PropTypes.number.isRequired,
  userAnswers: PropTypes.arrayOf(PropTypes.string).isRequired,
  correctAnswers: PropTypes.arrayOf(PropTypes.string).isRequired,
  total: PropTypes.number.isRequired,
  listQuestions: PropTypes.number.isRequired,
  completedTopic: PropTypes.bool.isRequired,
};
